import React from 'react';
import './App.scss';
import { Header } from './components/Header';
//import Footer from './components/Footer';
import { BrowserRouter as Router, Redirect, Route } from "react-router-dom";


//Declare New Components Here
import Home from './components/Home';
import PersonalDetails from "./components/PersonalDetails.jsx";
import LoanCalculator from "./components/LoanCalculator";
import ReviewDetails from "./components/ReviewDetails";
import errorscreen from "./components/error";

function App() {
  return (
    <Router>
      <div className="content">
        <Header projectName={'mbank_flexicash'} />
        <Route exact path="/" ><Redirect to="/flexicash" /></Route>
        <Route exact path="/flexicash" component={PersonalDetails} />
        <Route path="/flexicash/home" component={Home} />
        <Route path="/flexicash/loancalc" component={LoanCalculator} />
        <Route path="/flexicash/ReviewDetails" component={ReviewDetails} />
        <Route path="/flexicash/error" component={errorscreen} />

      </div>
      <br></br><br></br>
      {/* <div className="footer">
          <Footer />
        </div> */}
    </Router>
  );
}


export default App;
